import { Trans, useTranslation } from '@ecomm/i18n'
import React from 'react'

export const ProBusinessDescription = () => {
  const { t } = useTranslation('maps')
  return <Trans t={t} i18nKey="plan-description.pro-business" />
}
